import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Rating ,Menu , MenuItem } from "@mui/material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment-timezone';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch , useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";

//Services
import ratingsApi from "Services/Ratings";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  dayjs.extend(relativeTime);
  dayjs.extend(customParseFormat);

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);   
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const timezone = useSelector((state) => state.timezone.timezone);

  // Get Passenger list api
  const getUserratings = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        //console.log('res?.data?.data?.data-->',res?.data?.data?.data);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    ratingsApi
      .getUserratingsList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  const getAllUserratings = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    ratingsApi
      .getUserratingsList({ page:1, limit: "unlimited" })
      .then(onSuccess, onFailure);
  }, []);  

  useEffect(() => {
    getUserratings();
     getAllUserratings();   
  }, [getUserratings]);

  const handleDownloadAll = () => {
     const csv = Papa.unparse(bulkformatteddatas);
     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
     const url = URL.createObjectURL(blob);
     const link = document.createElement("a");
     link.href = url;
     link.setAttribute("download", "All Userratings.csv");
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   };  

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15, 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("Booking ID", columnWidths[1]),
        padText("Passenger name", columnWidths[2]),
        padText("Driver name", columnWidths[3]),
        padText("Rating", columnWidths[4]),
        padText("Date & time", columnWidths[5]),
        padText("Comments", columnWidths[6]),
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.bookingId, columnWidths[1]),
            padText(row.passengername, columnWidths[2]),
            padText(row.drivername, columnWidths[3]),
            padText(row.rating, columnWidths[4]),
            padText(row.dateandtime, columnWidths[5]),
            padText(row.comments, columnWidths[6]),
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Userratings.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Userratings.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.bookingId,
      row.passengername,
      row.drivername,
      row.rating,
      row.dateandtime,
      row.comments
    ]);
    doc.autoTable({
      head: [["S.NO","Booking ID","Passenger name","Driver name","Rating","Date & time","Comments"]],
      body: tableData,
    });
    doc.save("Userratings.pdf");
  };

function formatDate(inputDate) {
  if (!inputDate) return "--";

  // Handle MongoDB date object: { $date: "..." }
  const dateValue = inputDate?.$date || inputDate;

  if (!dateValue) return "--";

  // Fallback timezone if undefined
  const tz = timezone || "UTC";

  // Validate date before formatting
  if (!moment(dateValue).isValid()) return "--";

  return moment(dateValue).tz(tz).format("YYYY-MM-DD hh:mm A");
}


  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    bookingId: data?.bookingId,
    passengername: data?.userdetails?.user_name,
    drivername: data?.driverdetails?.user_name,
    rating: data?.rating,
    dateandtime: formatDate(data?.createdAt),
    comments: data?.comments == "" ? "No Comments" : data?.comments,
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingId,
    "Passenger name":row.passengername,
    "Driver name": row.drivername,
    "Rating": row.rating,
    "Date & time": row.dateandtime,
    "Comments": row.comments,
  }));
  
  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
      sno: calculateSno(page, pageSize, index),
    bookingId: data?.bookingId,
    passengername: data?.userdetails?.user_name,
    drivername: data?.userdetails?.user_name,
    rating: data?.rating,
    dateandtime: formatDate(data?.createdAt),
    comments: data?.comments == "" ? "No Comments" : data?.comments,
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
     "S.NO": row.sno,
    "Booking ID":row.bookingId,
    "Passenger name":row.passengername,
    "Driver name": row.drivername,
    "Rating": row.rating,
    "Date & time": row.dateandtime,
    "Comments": row.comments,
  }));  

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingId",
      headerName: "Booking Id",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingId}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "passengername",
      headerName: "Passenger name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.passengername}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "drivername",
      headerName: "Driver name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.drivername}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "rating",
      headerName: "Rating",
      flex:0.6,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
            <Rating
        name="read-only"
        value={Number(params?.row?.rating) || 0}
        readOnly
        precision={0.5}
        size="small"
      />
            </div>
          </>
        );
      },
    },
    {
      field: "dateandtime",
      headerName: "Date & time",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        const inputDate = params?.row?.dateandtime;
        const parsedDate = dayjs(inputDate, "YYYY-MM-DD hh:mm A");
        const formattedDate = parsedDate.isValid() ? parsedDate.fromNow() : "Invalid date";
    
        return (
          <>
          <div>
            <Typography variant="body2">{formattedDate}</Typography>
          </div>
          </>
        );
      },
    },
    {
      field: "comments",
      headerName: "Comments",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.comments}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
                      <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={handleDownloadAll}>
                      Download ALL
                      </Button>
                      </Grid>            
        <Grid item xs={8} md={8} lg={8} xl={8} className={classes.addBtn}>
        </Grid>
        <Grid item xs={12} sx={{margin:"26px  0px "}}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default Passenger;
